import { flushSync } from 'react-dom';

const SUBMIT_STEPS = {
  default: ['Preparing…', 'Connecting securely…', 'Almost there…'],
  client: ['Validating details…', 'Setting up login…', 'Saving client record…'],
  employee: ['Adding team member…', 'Creating credentials…', 'Syncing directory…'],
  invoice: ['Building invoice…', 'Generating tasks…', 'Saving to ledger…'],
  task: ['Creating task…', 'Updating timeline…', 'Notifying team…'],
  payment: ['Recording payment…', 'Updating balances…', 'Notifying reviewers…'],
  auth: ['Verifying credentials…', 'Starting secure session…', 'Welcome back…'],
  reset: ['Updating password…', 'Securing your account…', 'Done in a moment…'],
  submit: ['Uploading files…', 'Saving submission…', 'Updating task status…'],
  ticket: ['Creating ticket…', 'Routing to team…', 'Saving details…'],
  marketplace: ['Sending to sales team…', 'Recording your services…', 'Notifying your account manager…'],
};

/** Show global submit overlay while `fn` runs; cycles status lines on long requests. */
export function runSubmitting(setOverlay, label, fn, kind = 'default') {
  const steps = SUBMIT_STEPS[kind] || SUBMIT_STEPS.default;
  let i = 0;
  flushSync(() => setOverlay({ label, step: steps[0] }));
  const timer = setInterval(() => {
    i = (i + 1) % steps.length;
    setOverlay((prev) => (prev ? { ...prev, step: steps[i] } : null));
  }, 1600);
  return Promise.resolve(fn()).finally(() => {
    clearInterval(timer);
    setOverlay(null);
  });
}
